import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { GetUnpagedPhonebookRequestAction, addContactRequestAction, getAllContactsRequestAction, resetContactPropsAction } from '../../../../service/actions/contactActions'
import { useSelector } from 'react-redux'
import CustomModal from '../../../../components/CroreUIModal'
import { CCol, CFormInput, CFormLabel, CFormSelect, CFormText, CRow, CSpinner } from '@coreui/react'
import CustomValuesHook from '../../../../Hooks/customValuesHook'
import { PhoneBook } from '../../../../service/interfaces/contacts'
import './style.scss'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const AddContact = ({ display, setDisplay, number }: { display: boolean, setDisplay: Function, number: string }) => {
    const phonebookList = useSelector((state: any) => state.contactReducer.unpagedPhonebook)
    const pending = useSelector((state: any) => state.contactReducer.addContactPending)
    const success = useSelector((state: any) => state.contactReducer.addContactSuccess)
    const dispatch = useDispatch()

    const [contactStates, setContactStates] = CustomValuesHook({ name: "", nameFamily: "", phonebook: "" })
    const { t } = useTranslation()


    useEffect(() => {
        dispatch(getAllContactsRequestAction({
            pageNumber: 1,
            pageSize: 1000,
            disablePaging: false,
            whereConditionText: "",
            sortText: "",
        }))
        dispatch(GetUnpagedPhonebookRequestAction({
            pageSize: 1000,
            pageNumber: 1,
            disablePaging: true,
            sortText: '',
            whereConditionText: ''
        }))
    }, [])

    useEffect(() => {
        if (success) {
            setContactStates({ name: "", nameFamily: "", phonebook: "" })
            dispatch(getAllContactsRequestAction({
                pageNumber: 1,
                pageSize: 1000,
                disablePaging: false,
                whereConditionText: "",
                sortText: "",
            }))
            setDisplay()
            dispatch(resetContactPropsAction())

        }
    }, [success])

    const bodyComponent = () => {
        return (<CRow>
            <CCol lg={6} xs={12} >
                <CFormLabel htmlFor="nameInput">{t('NAME')}
                    <span className="required"> * </span>
                </CFormLabel>
                <div className='position-relative'>
                    <CFormInput
                        value={contactStates.name}
                        onChange={(e) => setContactStates({ name: e.target.value })}
                        type="text"
                        id="nameInput"
                        required
                    />
                </div>
            </CCol>
            <CCol lg={6} xs={12} >
                <CFormLabel htmlFor="nameInput">{t('LAST_NAME')}
                    <span className="required"> * </span>
                </CFormLabel>
                <div className='position-relative'>
                    <CFormInput
                        value={contactStates.nameFamily}
                        onChange={(e) => setContactStates({ nameFamily: e.target.value })}
                        type="text"
                        id="nameInput"
                        required
                    />
                </div>
            </CCol>
            <CCol lg={6} xs={12} className='p-4'>
                <CFormLabel htmlFor="nameInput">{t('PHONE_BOOK')}
                    <span className="required"> * </span>
                </CFormLabel>
                <div className='position-relative'>
                    <CFormSelect
                        className='form-control mx-2'
                        value={contactStates.phoneBookId}
                        onChange={(e) => setContactStates({ phoneBookId: e.target.value })}
                    >
                        <option value={''}>{t('SELECT_PHONE_BOOK')}</option>
                        {phonebookList?.data.map((item: PhoneBook, idx: number) =>
                            <option key={idx} value={item.id}>{item.name}</option>)}

                    </CFormSelect>

                </div>
            </CCol>
            {phonebookList?.data.length === 0 && <CCol lg={12} xs={12} > <CFormText>
                {t('FOR_REGISTER_CONTACT_YOU_NEED_PHONE_BOOK')}
                <Link to={'/contacts/phonebook'} >{t('REGISTER_MANAGMENT_PHONE')}</Link>
            </CFormText></CCol>}
        </CRow>)
    }

    const handleAddContact = () => {

        dispatch(addContactRequestAction({
            phoneBookId: contactStates.phoneBookId,
            // contactCategoryIds: null,
            name: contactStates.name,
            familyName: contactStates.nameFamily,
            defaultNumber: number,
            isActive: true,
            isPin: false,
            isStar: false,
            isInBlackList: false,
            color: 'Empty',
            contactCategoryIds: [],
            number2: undefined,
            number3: undefined,
            number4: undefined
        }))
    }
    const validationForm = () => {
        if (!contactStates.name || !contactStates.nameFamily || !contactStates.phoneBookId) {
            return true
        }
        return false
    }
    const footerComponent = () => {
        return (<div className='d-flex justify-content-end'>
            <button className='btn btn-default mx-2' onClick={() => setDisplay(false)}>{t('CANCLE')}</button>
            <button className='btn btn-primary'
                disabled={pending || validationForm()}
                onClick={handleAddContact} >{pending ? <CSpinner size="sm" /> : t('REGISTER')}</button>
        </div>)
    }
    return (
        <CustomModal
            setShow={() => setDisplay(false)}
            title={() => <div> {t('SAVE_NUMBER')} {number}</div>}
            component={bodyComponent}
            show={display}
            footerComponent={footerComponent}
            size={'lg'}
            backdrop={true}
        />
    )
}

export default AddContact